'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactGridLayout = require('react-grid-layout');

var _reactGridLayout2 = _interopRequireDefault(_reactGridLayout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

exports["default"] = _reactGridLayout2["default"];
module.exports = exports['default'];